
'use strict';

var React = require('react');
var TextInput = require('../Common/TextInput.jsx');
var ContentService = require('../../services/ContentService');

var Email = React.createClass({
    propTypes: {
        index: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
        hideWhyWeAskText: React.PropTypes.bool,
        section: React.PropTypes.string,
        isBusiness: React.PropTypes.bool
    },

    getDefaultProps: function () {
        return {
            hideWhyWeAskText: false,
            isBusiness: false,
            mandatory: false,
            readonly: false,
            section: '',
            index: ''
        };
    },

    render: function () {
        var ydContent = ContentService.getContent().yourDetails;
        var contextualMessage = this.props.isBusiness ? ydContent.businessEmailCopy : ydContent.emailCopy;
        return (
            <div>
                <TextInput label="Email address"
                           id={this.props.section + 'emailAddress' + this.props.index}
                           value={this.props.value}
                           onBlur={this.props.onEmailChange}
                           mandatory= {this.props.readonly || this.props.mandatory}
                           errorList={this.props.errorList}
                           model="emailAddress"
                           contextualMessage={(!this.props.value || this.props.hideWhyWeAskText) ? null : contextualMessage}
                           isDisabled={this.props.readonly}/>
            </div>
		);
    }
});

module.exports = Email;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/Common/Email.jsx